import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled, { keyframes } from 'styled-components'
import { Link } from "gatsby"

class OtrosServices extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;            
            background-size: cover;
            .heading {
                width: 100%;
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 50px 0;
        `
        const gradientAnimation = keyframes`
            0% {
                background-position: 15% 0%;
            }
            50% {
                background-position: 85% 100%;
            }
            100% {
                background-position: 15% 0%;
            }
        `

        const ColorAnimation = keyframes`
            0%  {background: #04e5e5;}
            10% {background: #c1eb18;}
            20% {background: #ef4e7b;}
            30% {background: #a166ab;}
            40% {background: #5073b8;}
            50% {background: #04e5e5;}
            60% {background: #07b39b;}
            70% {background: #6fba82;}
            80% {background: #5073b8;}
            90% {background: #1098ad;}
            100% {background: #A1002E;}
        `

        const AnimatedShadow = keyframes`
            0%   {box-shadow: 0 28px 60px rgba(4, 229, 229, .5);}
            10%  {box-shadow: 0 28px 60px rgba(193, 235, 24, .5);}
            20%  {box-shadow: 0 28px 60px rgba(239, 78, 123, .5);}
            30%  {box-shadow: 0 28px 60px rgba(161, 102, 171, .5);}
            40% {box-shadow: 0 28px 60px rgba(80, 115, 184, .5);}
            50% {box-shadow: 0 28px 60px rgba(4, 229, 229, .5);}
            60% {box-shadow: 0 28px 60px rgba(7, 179, 155, .5);}
            70% {box-shadow: 0 28px 60px rgba(111, 186, 130, .5);}
            80% {box-shadow: 0 28px 60px rgba(80, 115, 184, .5);}
            90% {box-shadow: 0 28px 60px rgba(16, 152, 173, .5);}
            100% {box-shadow: 0 28px 60px rgba(193, 235, 24, .5);}
        `
        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                animation: ${AnimatedShadow} 10s infinite alternate;
                transform: translateY(-10px);
            }
        `
        const ServiceHeading = styled.h2`
            font-size: 40px;
            font-weight: 500;
            font-family: 'Teko';
            color: #fff;
        `
        const ServiceHeading3 = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            margin: 30px 0 10px 0;
        `

        const ServiceHeadinga = styled(Link)`            
            color: #c1eb18;
            transition: .5s;            
            &:hover {
              color: #ffffff;
              text-decoration: none;
            }
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
            margin: auto;
         `
        const ServiceIcon = styled.div`
            width: 120px;
            height: 120px;
            margin: 0 auto 25px auto;
            background-color: #fff;
            border-radius: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(120deg, #F3F952, #9EE14D, #66DF44, #c1eb18, #adec22, #51df29, #65ff00, #c1eb18);
            background-size: 300% 300%;
            animation: ${gradientAnimation} 5s ease-in-out infinite;
            img {
                max-height: 70px;
            }
        `

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #c5c5c5;
            font-weight: 300;
            font-size: 16px;
            margin: 5px 0px;
            text-align: left;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 10px;
                height: 10px;
                width: 10px;
                margin-right: 10px;
                position: relative;
                bottom: 2.5px;
                animation: ${ColorAnimation} 10s infinite alternate;
            }
        `

        const Text = styled.p`
          font-size: 20px;          
          font-weight: 300;
          color: #ffffff;
          text-align: center;
          margin-bottom: 50px;
        `
        const Heading2 = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 150px;
            font-size: 95px;
            line-height: 110px;
            font-family: Teko;
            font-weight: 500;
            color: rgb(255, 255, 255);
            text-align: center;
            text-transform: uppercase;          
            `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
            `

        return (
            <Section>
                <ServiceContainer>
                    <Container>
                        <Row>
                            <Heading2>Mas <ColorV>servicios</ColorV> para su <ColorV>Empresa</ColorV></Heading2>
                            <Text>
                                Servicios y recursos web de calidad para posicionar y dar seguridad a su empresa.
                            </Text>
                        </Row>
                        <Row>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image1} alt="Sello SiteLock en Colombia" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Sello SiteLock
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceList>
                                        <ServiceListElement>
                                            Proteja su sitio web y reputación
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Escaneo de Malware
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Escaneo aplicaciones web, inyección SQL y XSS
                                        </ServiceListElement>
                                    </ServiceList>
                                    <ServiceHeading3>
                                        <ServiceHeadinga to="/sitelock">
                                            SiteLock
                                        </ServiceHeadinga>
                                    </ServiceHeading3>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image2} alt="Asesores y consultores en Gobierno Digital en Colombia" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Gobierno Digital
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceList>
                                        <ServiceListElement>
                                            El Habilitador de Seguridad y Privacidad es uno de los ejes fundamentales de la Política de Gobierno Digital.
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Implementación de Estándares de Ciberseguridad.
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Diagnóstico, Capacitación, Implementación y Auditoría.
                                        </ServiceListElement>
                                    </ServiceList>
                                    <ServiceHeading3>
                                        <ServiceHeadinga to="/gobierno-digital-colombia">
                                            Gobierno Digital
                                        </ServiceHeadinga>
                                    </ServiceHeading3>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image3} alt="Correo empresarial para Pymes" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Correo profesional
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceList>
                                        <ServiceListElement>
                                            Correo robusto para su empresa
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Almacenamiento abundante
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Compartir contactos, tareas, calendarios y archivos
                                        </ServiceListElement>
                                    </ServiceList>
                                    <ServiceHeading3>
                                        <ServiceHeadinga to="/correo-corporativo/">
                                            Email Empresarial
                                        </ServiceHeadinga>
                                    </ServiceHeading3>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image4} alt="SEO en Pereira" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Posicionamiento web
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceList>
                                        <ServiceListElement>
                                            Captar trafico de calidad
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Mejorar la visibilidad
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Mejorar la indexación en Google (Posicionamiento)
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            SEO en Pereira
                                        </ServiceListElement>
                                    </ServiceList>
                                    <ServiceHeading3>
                                        <ServiceHeadinga to="/seo">
                                            SEO
                                        </ServiceHeadinga>
                                    </ServiceHeading3>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image5} alt="Google Workspace en Colombia" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Apps empresariales
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceList>
                                        <ServiceListElement>
                                            Gmail y Google calendar
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Drive y Meet
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Documentos de Google, hojas de calculo, presentaciones y formularios
                                        </ServiceListElement>
                                    </ServiceList>
                                    <ServiceHeading3>
                                        <ServiceHeadinga to="/google-workspace">
                                            Google Workspace
                                        </ServiceHeadinga>
                                    </ServiceHeading3>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image6} alt="Consultora en SGSI e ISO27001 en Colombia" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        SGSI - ISO27001
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceList>
                                        <ServiceListElement>
                                            Sistema de Gestión de Seguridad de la Información SGSI
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Consultoría en servicios web
                                        </ServiceListElement>
                                        <ServiceListElement>
                                            Entrenamiento de personal en seguridad de la información
                                        </ServiceListElement>
                                    </ServiceList>
                                    <ServiceHeading3>
                                        <ServiceHeadinga to="/sgsi-iso27001-colombia">
                                            Auditoría GRATUITA
                                        </ServiceHeadinga>
                                    </ServiceHeading3>
                                </ServiceElement>

                            </Col>
                        </Row>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}
const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image2: file(relativePath: { eq: "icons/ciberseguridad.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image1: file(relativePath: { eq: "icons/virus.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image4: file(relativePath: { eq: "icons/upgrade.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/email.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image6: file(relativePath: { eq: "icons/medal.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image5: file(relativePath: { eq: "icons/google-workspace.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }          
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
            const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
            const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);
            return <OtrosServices data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6}{...props} />;
        }}
    />
);

export default Iconos;